module.exports = __webpack_public_path__ + "static/media/skip.2f08f964.png";